import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-option',
  imports: [CommonModule],
  templateUrl: './option.html',
  styleUrl: './option.scss',
})
export class Option {
  @Input() text!: string;
  @Input() isActive!: boolean;
  @Output() optionClick = new EventEmitter<void>();

  handleClick() {
    this.optionClick.emit();
  }
}
